import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'

// Legacy street-turn-match Slack notifications and bookmarks point at
// /admin/streetturns/:id[/:ref] (svc-marketplace sendStreetTurnMatchSlackMessageHook).
// Strip the /admin prefix to reach the public street-turn routes, mirroring the
// legacy AdminStreetTurns redirect (location.pathname.replace('/admin', '')).
export function StreetTurnsAdminRedirect() {
  const { pathname, search } = useLocation()
  return <Navigate to={`${pathname.replace('/admin', '')}${search}`} replace />
}

// Legacy detail links carried a /:referenceNum suffix (StreetTurnsTable review
// link). The new detail route is a single :streetTurnId segment, so drop the
// suffix and redirect to the canonical URL the detail page's useMatch expects.
export function StreetTurnDetailSuffixRedirect() {
  const { streetTurnId } = useParams()
  return <Navigate to={`/streetturns/${streetTurnId}`} replace />
}
